import { CurrencyUtils } from '@Core/Currencies/CurrencyUtils';
import { Game } from '@Game/Game';
import { GameStore } from '@GameStore/GameStore';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import EventsCenter from '@Managers/Events/EventsCenter';
import { ALL_EVENTS_LIST } from '@Managers/Events/GameEvents';

export class FreeSpinsManager {
    private readonly game: Game;
    private readonly gameStore: GameStore;

    constructor(game: Game) {
        this.game = game;
        this.gameStore = this.game.gameStore;

        EventsCenter.on(ALL_EVENTS_LIST.GAME_START, this.onInit, this);
        EventsCenter.on(ALL_EVENTS_LIST.IDLE_STATE, this.stateCheck, this);
    }

    public stateCheck(): void {
        const freeSpinsState = this.gameStore.get(EGameStoreKeys.Account).bonuses?.freeSpins;

        if (freeSpinsState) {
            let clone = structuredClone(this.gameStore.get(EGameStoreKeys.Account));

            if (clone.bonuses.freeSpins) {
                clone.bonuses.freeSpins.suspend = this.gameStore.get(EGameStoreKeys.IsFreeGamesMode) ? true : false;
                this.gameStore.set(EGameStoreKeys.Account, clone, true);
            }
        }
    }

    public onInit(): void {
        this.stateCheck();
        const freeSpinsState = this.gameStore.get(EGameStoreKeys.Account).bonuses?.freeSpins;

        if (freeSpinsState) {
            const betSteps = this.gameStore.get(EGameStoreKeys.BetState).betSteps;
            const betIndex = betSteps.map((e) => e.raw).indexOf(freeSpinsState.wagerCost);
            this.gameStore.set(EGameStoreKeys.BetState, { value: CurrencyUtils.createCurrencyValue(freeSpinsState.wagerCost), index: betIndex }, true);
        }
    }
}
